import { Chip } from '@agro-club/frontend-shared'
import styled from 'styled-components'

export const DiscountChip = styled(Chip)`
  height: 24px;
  font-size: 14px;
  margin-right: 8px;
  padding: 4px 8px;
`
